import React from 'react';
import { Search } from 'lucide-react';

const Banner = () => {
  return (
       <div className="relative bg-[#007177] overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="./LungBanner.png"
          alt="banner"
          className="hidden md:block w-full h-full object-cover"
        />
        <img
          src="./LungBannerMobiles.png"
          alt="banner"
          className="md:hidden w-full h-full object-cover"
        />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="banner-child h-[320px] sm:h-[400px] md:h-[480px] flex items-start md:items-center pt-10 md:pt-0">
          <div>
            <h1 className="text-3xl sm:text-5xl md:text-6xl font-extrabold text-white leading-tight drop-shadow-md">
              <span className="block">Find the</span>
              <span className="block">Right Care</span>
            </h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner; 